import React, { useState } from "react";
import axios from "axios";
import { useNotify } from "react-admin";

import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";

import { apiUrl } from "cms-config/domain";
import { timestamp } from "ev-schema";

const TestLead = () => {
    const notify = useNotify();

    const [values, setValues] = useState({
        name: "",
        email: "",
        phone: "",
        message: ""
    });
    const [sending, setSending] = useState(false);
    const [lastResult, setLastResult] = useState(null);

    const handleChange = field => e =>
        setValues({ ...values, [field]: e.target.value });

    const handleSubmit = async e => {
        e.preventDefault();

        if (!values.email.trim() && !values.phone.trim()) {
            notify("Please fill in an email address or phone number", "warning");
            return;
        }

        setSending(true);
        setLastResult(null);
        try {
            const { data } = await axios.post(`${apiUrl}/test-lead`, values, {
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    ApiVersion: timestamp
                }
            });
            setLastResult(data);
            notify("Test lead submitted");
        } catch (err) {
            notify(
                (err.response && err.response.data && err.response.data.error) ||
                    "Sending test lead failed",
                "warning"
            );
        }
        setSending(false);
    };

    return (
        <Card style={{ maxWidth: 600 }}>
            <CardContent>
                <Typography variant="h6" gutterBottom>
                    Test lead-form submission
                </Typography>
                <Typography variant="body2" color="textSecondary" gutterBottom>
                    Sends a submission through the exact same flow as the Google
                    Ads lead form webhook: the customer receives the lead
                    confirmation email/SMS with the extra-info link, a customer
                    is created here in the CMS, and the request appears in
                    Evobooker with source &ldquo;leadform&rdquo;.
                </Typography>
                <form onSubmit={handleSubmit}>
                    <TextField
                        label="Name"
                        value={values.name}
                        onChange={handleChange("name")}
                        fullWidth
                        margin="normal"
                        variant="filled"
                    />
                    <TextField
                        label="Email"
                        type="email"
                        value={values.email}
                        onChange={handleChange("email")}
                        fullWidth
                        margin="normal"
                        variant="filled"
                    />
                    <TextField
                        label="Phone number"
                        value={values.phone}
                        onChange={handleChange("phone")}
                        fullWidth
                        margin="normal"
                        variant="filled"
                        helperText="Use international format (e.g. +31612345678) to also test the SMS"
                    />
                    <TextField
                        label="What do you want to book? (optional)"
                        value={values.message}
                        onChange={handleChange("message")}
                        fullWidth
                        margin="normal"
                        variant="filled"
                        multiline
                    />
                    <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        disabled={sending}
                        startIcon={
                            sending ? <CircularProgress size={18} /> : null
                        }
                        style={{ marginTop: 16 }}
                    >
                        Send test lead
                    </Button>
                </form>
                {lastResult && (
                    <Typography
                        variant="body2"
                        style={{ marginTop: 16, wordBreak: "break-all" }}
                    >
                        Sent! Lead id: {lastResult.lead_id}
                        <br />
                        The confirmation email/SMS arrives after ~2 minutes.
                    </Typography>
                )}
            </CardContent>
        </Card>
    );
};

export default TestLead;
